import axiosInstance from '../../utils/setupAxios';
import {
  FETCH_LOGS_REQUEST,
  FETCH_LOGS_SUCCESS,
  FETCH_LOGS_FAILURE,
  FETCH_LOGS_DATE_CHART_REQUEST,
  FETCH_LOGS_DATE_CHART_SUCCESS,
  FETCH_LOGS_DATE_CHART_FAILURE,
  FETCH_LOGS_TYPE_CHART_REQUEST,
  FETCH_LOGS_TYPE_CHART_SUCCESS,
  FETCH_LOGS_TYPE_CHART_FAILURE
} from '../types/logTypes';

export const fetchLogs = (page = 1, itemsPerPage = 10) => async (dispatch) => {
  dispatch({ type: FETCH_LOGS_REQUEST });
  try {
    const res = await axiosInstance.get(`/coins/logs/get?page=${page}&items_per_page=${itemsPerPage}`);
    dispatch({ type: FETCH_LOGS_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: FETCH_LOGS_FAILURE, error });
  }
};

export const fetchLogsDateChart = () => async (dispatch) => {
  dispatch({ type: FETCH_LOGS_DATE_CHART_REQUEST });
  try {
    const res = await axiosInstance.get('/coins/logs/get-chart');
    dispatch({ type: FETCH_LOGS_DATE_CHART_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: FETCH_LOGS_DATE_CHART_FAILURE, error });
  }
};

export const fetchLogsTypeChart = () => async (dispatch) => {
  dispatch({ type: FETCH_LOGS_TYPE_CHART_REQUEST });
  try {
    const res = await axiosInstance.get('/coins/logs/get-bar-chart');
    dispatch({ type: FETCH_LOGS_TYPE_CHART_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: FETCH_LOGS_TYPE_CHART_FAILURE, error });
  }
}; 